module.exports = __webpack_public_path__ + "img/4-4.b6423b0d.svg";